import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../../core/config/core.modal-helpers';

@Component({
  selector: 'trackeritem-validation-failures-modal',
  template: require('./trackeritem.validations.modal.component.html')
})
export class TrackeritemValidationFailuresModalComponent extends ModalComponent  implements OnInit  {
  footerMessage = '';
  @Input() trackeritem: any;
  @Input() tracker: any;
  @Input() tags: any;
  @Input() errors: any;
  @Input() options: any;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

  allowUpdate: boolean = false;
  isLoaded: boolean = false;
  fieldValidationMode: boolean = true;

  constructor () {
    super();
  }

  ngOnInit(): void {
    this.fieldValidationMode = true;
    this.allowUpdate = !(this.trackeritem.lockStatus > 0);
    this.isLoaded = true;
  }

  checkValidationFailureMode(fieldName: string): boolean {
    return !this.errors?.[fieldName]?.hasError || false;
  }

  cancel(): void {
    this.onCancel.emit({});
    this.closeModal();
  }

  save(): void {
    this.onUpdate.emit({trackeritem: this.trackeritem, options: this.options});
    this.closeModal();
  }

  tagsUpdated($event) {
    this.trackeritem.tags = $event;
  }
}
